import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';
import { compose, Dispatch } from 'redux';
import { Form, Field } from 'react-final-form';

import SubmitButton from '../common/SubmitButton';
import Alerts from '../common/Alerts';
import Translation from '../common/Translation';
import CancelButton from '../common/CancelButton';
import Input from '../common/Input';
import DateTimePicker from '../common/DateTimePicker';
import DropDown from '../common/DropDown';
import Condition from '../common/utils/Condition';
import NumericTextBox from './../common/NumericTextBox';

import * as enums from '../../common/enums';
import Switch from '../common/Switch';
import { BaseDetailProps } from '../common/types/baseDetail';
import OutageNotification from '../../entities/outageNotification';

class OutageNotificationDetail extends React.Component<OutageNotificationDetailProps> {
    handleOnSubmit = (values: object) => {
        this.props.submitAction(values as OutageNotification);
    };

    handleOnCancel = (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
        event.preventDefault();

        this.props.cancelAction();
    };

    translatedFormValidation = (values: object) => {
        const { t } = this.props;

        const typedValues = values as OutageNotification;
        const errors: Partial<Record<keyof OutageNotification, string>> = {};

        if (!typedValues.name) {
            errors.name = t('NameIsRequired');
        }

        if (!typedValues.text) {
            errors.text = t('TextIsRequired');
        }

        if (!typedValues.platformEnumDescription) {
            errors.platformEnumDescription = t('PlatformIsRequired');
        }

        if (!typedValues.notificationFrom) {
            errors.notificationFrom = t('NotificationFromIsRequired');
        }

        if (!typedValues.notificationTo) {
            errors.notificationTo = t('NotificationToIsRequired');
        }

        const outageFrom = typedValues.outageFrom;
        const outageTo = typedValues.outageTo;
        const notificationFrom = typedValues.notificationFrom;
        const notificationTo = typedValues.notificationTo;
        const isUpdateForced = typedValues.isUpdateForced;
        const version = typedValues.version;
        const conditionEnumDescription = typedValues.conditionEnumDescription;
        const filterEnumDescriptionn = typedValues.filterEnumDescription;

        if (notificationTo && notificationFrom && notificationTo < notificationFrom) {
            errors.notificationTo = t('NotificationToIsOutOfRange');
        }

        if (notificationTo && notificationFrom && outageFrom && (outageFrom < notificationFrom || outageFrom > notificationTo)) {
            errors.outageFrom = t('OutageFromIsOutOfRange');
        }

        if (outageFrom && !outageTo) {
            errors.outageTo = t('OutageToIsRequired');
        }

        if (
            notificationTo &&
            notificationFrom &&
            outageTo &&
            outageFrom &&
            (outageTo < notificationFrom || outageTo > notificationTo || outageTo < outageFrom)
        ) {
            errors.outageTo = t('OutageToIsOutOfRange');
        }

        if (outageTo && !outageFrom) {
            errors.outageFrom = t('OutageFromIsRequired');
        }

        if (filterEnumDescriptionn?.value === enums.OUTAGE_NOTIFICATION_FILTER_TYPE_ENUM.MOBILE_APP_VERSION && !version) {
            errors.version = t('VersionIsRequired');
        }

        if (isUpdateForced && filterEnumDescriptionn?.value != enums.OUTAGE_NOTIFICATION_FILTER_TYPE_ENUM.MOBILE_APP_VERSION) {
            errors.filterEnumDescription = t('FilterByVersionIsRequired');
        }

        if (filterEnumDescriptionn?.value === enums.OUTAGE_NOTIFICATION_FILTER_TYPE_ENUM.MOBILE_APP_VERSION && !conditionEnumDescription) {
            errors.conditionEnumDescription = t('ConditionIsRequired');
        }

        return errors;
    };

    filterByVersion = (value: any) => {
        return value === enums.OUTAGE_NOTIFICATION_FILTER_TYPE[1];
    };

    filterByUserGroup = (value: any) => {
        return value === enums.OUTAGE_NOTIFICATION_FILTER_TYPE[2];
    };

    render() {
        const { initialValues, headerText } = this.props;

        return (
            <div>
                <div className="content-header">
                    <h1>{headerText}</h1>
                </div>
                <div className="content-wrapper">
                    <Alerts />
                    <div className="panel card col-xs-12 col-sm-6">
                        <Form
                            validate={this.translatedFormValidation}
                            onSubmit={this.handleOnSubmit}
                            initialValues={initialValues}
                            render={({ handleSubmit }) => (
                                <form className="k-form" onSubmit={handleSubmit}>
                                    <label className="k-form-field" htmlFor="name">
                                        <span>
                                            <Translation tKey="Name" />
                                        </span>
                                        <Field name="name" component={Input} />
                                    </label>

                                    <label className="k-form-field">
                                        <span>
                                            <Translation tKey="Platform" />
                                        </span>
                                        <Field
                                            name="platformEnumDescription"
                                            component={DropDown}
                                            textField="text"
                                            dataSource={enums.PLATFORMA_TYPES}
                                        />
                                    </label>

                                    <div className="row">
                                        <label className="k-form-field col-xs-12 col-sm-6" htmlFor="notificationFrom">
                                            <span>
                                                <Translation tKey="NotificationFrom" />
                                            </span>
                                            <Field name="notificationFrom" component={DateTimePicker} />
                                        </label>

                                        <label className="k-form-field col-xs-12 col-sm-6" htmlFor="notificationTo">
                                            <span>
                                                <Translation tKey="NotificationTo" />
                                            </span>
                                            <Field name="notificationTo" component={DateTimePicker} />
                                        </label>
                                    </div>

                                    <div className="row">
                                        <label className="k-form-field col-xs-12 col-sm-6" htmlFor="outageFrom">
                                            <span>
                                                <Translation tKey="OutageFrom" />
                                            </span>
                                            <Field name="outageFrom" component={DateTimePicker} />
                                        </label>

                                        <label className="k-form-field col-xs-12 col-sm-6" htmlFor="outageTo">
                                            <span>
                                                <Translation tKey="OutageTo" />
                                            </span>
                                            <Field name="outageTo" component={DateTimePicker} />
                                        </label>
                                    </div>

                                    <label className="k-form-field">
                                        <span>
                                            <Translation tKey="OutageNotificationText" />
                                        </span>
                                        <Field name="text" component="textarea" className="k-textarea" rows="2" style={{ width: '100%' }} />
                                    </label>

                                    <label className="k-form-field" htmlFor="order">
                                        <span>
                                            <Translation tKey="Order" />
                                        </span>
                                        <Field name="order" component={NumericTextBox} />
                                    </label>

                                    <label className="k-form-field">
                                        <span>
                                            <Translation tKey="Filter" />
                                        </span>
                                        <Field
                                            name="filterEnumDescription"
                                            component={DropDown}
                                            textField="text"
                                            dataSource={enums.OUTAGE_NOTIFICATION_FILTER_TYPE}
                                        />
                                    </label>

                                    <Condition when="filterEnumDescription" is={this.filterByVersion}>
                                        <div className="row">
                                            <label className="k-form-field col-xs-12 col-sm-6">
                                                <span>
                                                    <Translation tKey="Condition" />
                                                </span>
                                                <Field
                                                    name="conditionEnumDescription"
                                                    component={DropDown}
                                                    textField="text"
                                                    dataSource={enums.OUTAGE_NOTIFICATION_CONDITION_TYPE}
                                                />
                                            </label>
                                            <label className="k-form-field col-xs-12 col-sm-6" htmlFor="version">
                                                <span>
                                                    <Translation tKey="Version" />
                                                </span>
                                                <Field name="version" component={Input} />
                                            </label>
                                        </div>
                                    </Condition>

                                    <Condition when="filterEnumDescription" is={this.filterByUserGroup}>
                                        <div className="row">
                                            <label className="k-form-field col-xs-12 col-sm-6" htmlFor="groupName">
                                                <span>
                                                    <Translation tKey="UserGroup" />
                                                </span>
                                                <Field name="groupName" component={Input} />
                                            </label>
                                        </div>
                                    </Condition>

                                    <div className="k-form-field">
                                        <span>
                                            <Translation tKey="IsUpdateForced" />
                                        </span>
                                        <Field name="isUpdateForced" component={Switch} />
                                    </div>

                                    <div className="footer">
                                        <SubmitButton>
                                            <Translation tKey="Save" />
                                        </SubmitButton>
                                        <CancelButton onClick={this.handleOnCancel}>
                                            <Translation tKey="Cancel" />
                                        </CancelButton>
                                    </div>
                                </form>
                            )}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export interface OutageNotificationDetailProps extends BaseDetailProps<OutageNotification>, OutageNotificationDetailStateProps {
    headerText: string;
}

export interface OutageNotificationDetailStateProps {
    lang: string;
}

export interface OutageNotificationDetailDispatchProps {}

const mapStateToProps = (state: any): OutageNotificationDetailStateProps => {
    return {
        lang: state.app.lang,
    };
};

const mapDispatchToProps = (dispatch: Dispatch<OutageNotificationDetailProps>): OutageNotificationDetailDispatchProps => {
    return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(OutageNotificationDetail);
